import I18n from './i18n';
import { getTimestampFromDate } from './format-date';

const getNationality = nationality => {
  const isMalaysian = ['MY', 'MYS', 'MALAYSIA', 'MALAYSIAN'].includes((nationality || '').toUpperCase().trim());
  if (isMalaysian) {
    return 'MYS';
  }
  return nationality;
};

const formatCustomer = customer => {
  const dateFormat = I18n.locale !== 'fr' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

  return {
    ...customer,
    nationality: getNationality(customer.nationality),
    birthdate: getTimestampFromDate(customer.birthdate, dateFormat),
    fullName: `${customer.givenName} ${customer.middleName || customer.familyName}`,
  };
};

export default formatCustomer;
